
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/global-climate-resilience-collective",
      function () {
        return require("private-next-pages/global-climate-resilience-collective.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/global-climate-resilience-collective"])
      });
    }
  